import Config from '../config/config';
import storageUtils from '@/utils/storageUtils';
class CommonUtils {
  /**
   * 根据当前浏览器可见高度计算缩放比例
   */
  static getZoomRatio() {
    const clientHeight = document.documentElement.clientHeight;
    const ratio = clientHeight / Config.fitHeight;
    return ratio;
  }

  /**
   * 获取url参数值
   * @param search 查询参数字符串
   * @param paramName 参数名称
   */
  static getParamValue(search, paramName) {
    let val = '';
    if (search && search.length > 0) {
      const paramKeyValue = search.substr(1, search.length - 1);
      paramKeyValue.split('&').forEach((p) => {
        if (p && p.split('=') && p.split('=').length === 2) {
          if (p.split('=')[0] === paramName) {
            val = p.split('=')[1];
          }
        }
      });
    }

    return val;
  }

  /**
   * 数组转对象
   */
  static arrayToObject(array, ignore = [], keyName = 'key', valueName = 'value') {
    let obj = {};
    if (array && array.length > 0) {
      array.forEach(p => {
        if (!ignore || ignore.length === 0 || ignore.indexOf(p[keyName]) < 0) {
          obj[p[keyName]] = p[valueName];
        }
      });
    }

    return obj;
  }

  /**
   * 对象转数组
   */
  static objToArray(obj, ignore = [], keyName = 'key', valueName = 'value') {
    let array = [];
    for (let prop in obj) {
      if (!ignore || ignore.length === 0 || ignore.indexOf(prop) < 0) {
        const data = {};
        data[keyName] = prop;
        data[valueName] = obj[prop];
        array.push(data);
      }
    }

    return array;
  }

  /**
   * 返回是否隐藏面包屑或导航
   * @param {String} search 查询参数
   * @returns 
   */
  static hideBreadCrumAndSider(search) {
    const hideParam = {
      hideSider: false,
      hideBreadcrum: false,
      hideHead: false
    };
    if (search && search.indexOf('hides') >= 0) {
      hideParam.hideSider = true;
    }

    if (search && search.indexOf('hideb') >= 0) {
      hideParam.hideBreadcrum = true;
    }

    if (search && search.indexOf('hideh') >= 0) {
      hideParam.hideHead = true;
    }

    return hideParam;
  }
  // JS生成UUID
  // static generateUUID() {
  //   var d = new Date().getTime();
  //   if (window.performance && typeof window.performance.now === "function") {
  //     d += performance.now(); //use high-precision timer if available
  //   }
  //   var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
  //     var r = (d + Math.random() * 16) % 16 | 0;
  //     d = Math.floor(d / 16);
  //     return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
  //   });
  //   return uuid;
  // }
  // JS生成UUID 方法2
  static generateUUID() {
    function S4() {
      return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    }
    return (S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4());
  }
  // 生成随机颜色
  static randomColor() {
    return 'rgb(' + [
      Math.round(Math.random() * 160),
      Math.round(Math.random() * 160),
      Math.round(Math.random() * 160)
    ].join(',') + ')';
  }
  // 根据node.js版本的node-iniparser改写了个JavaScript函数来解析INI文件内容，传入INI格式的字符串，返回一个json object。
  static parseINIString(data) {
    var regex = {
      section: /^\s*\s*([^]*)\s*\]\s*$/,
      // param: /^\s*([\w\.\-\_]+)\s*=\s*(.*?)\s*$/,
      param: /^\s*([\w.\-_]+)\s*=\s*(.*?)\s*$/,
      comment: /^\s*;.*$/
    };
    var value = {};
    var lines = data.split(/\r\n|\r|\n/);
    var section = null;
    lines.forEach(function (line) {
      if (regex.comment.test(line)) {
        return;
      } else if (regex.param.test(line)) {
        var match = line.match(regex.param);
        if (section) {
          value[section][match[1]] = match[2];
        } else {
          value[match[1]] = match[2];
        }
      } else if (regex.section.test(line)) {
        var match2 = line.match(regex.section);
        value[match2[1]] = {};
        section = match2[1];
      } else if (line.length === 0 && section) {
        section = null;
      };
    });
    return value;
  }
  // 关键词高亮
  static wordDictReplaceStr(strs) {
    let wordDicts = JSON.parse(storageUtils.get(Config.wordDictCode));
    if (strs && strs.length > 0 && wordDicts && wordDicts.length > 0) {
      for (let key of wordDicts) {
        if (key && key.length > 0) {
          let regExp = new RegExp( "\\b(?:" + key + ")+\\b", "ig" ); //正则表达式方法，完全匹配对应的关键字，且声明全局
          strs = strs.replace(regExp, `<span style="color:#0014ff">${key}</span>`);
        }
      }
    }
    return strs;
  }
  // 脱敏 str 脱敏字符串   startLength 前面显示的字符串长度 endLength 后面显示的字符串长度
  static getPhoneShow(str, startLength, endLength) {
    if (str === undefined || str.length === 0) {
      return '';
    }
    var length = str.length;
    if (length >= startLength + endLength) {
      return str.substring(0, startLength) + '*****' + str.substring(startLength + endLength, length);
    } else {
      return str;
    }
  }
}

export default CommonUtils;